import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { isEmpty } from 'lodash';

import SignInScreen from './SignInScreen';
import {
    lookupUser as lookupUserAction,
    logInUser as logInUserAction,
    signUpUser as signUpUserAction,
    linkAccountsOnLogin as linkAccountsOnLoginAction,
    moveBack as moveBackAction,
    clearAuthNotification as clearAuthNotificationAction,
    forceStld as forceStldAction,
    trackGetStartedClick as trackGetStartedClickAction,
    trackEmailMismatchAction,
    trackEmailConfirmationInput as trackEmailConfirmationAction,
} from '../../actions/auth';
import {
    sendResetPasswordEmail as sendResetPasswordEmailAction,
    sendEmailLinkAccount as sendEmailLinkAccountAction,
} from '../../actions/email';
import { OLD_trackLoginInsteadClick as trackLoginInsteadAction } from '../../actions/gaTracking';
import {
    socialLogInUserNotAuthorized as socialLogInUserNotAuthorizedAction,
    socialLogInUserAuthorized as socialLogInUserAuthorizedAction,
    socialSignUpUser as socialSignUpUserAction,
    socialConnectVerified as socialConnectVerifiedAction,
    socialProviderClick as socialProviderClickAction,
} from '../../actions/social';

import {
    trackSIWA_LookUpSuccessWithEmail,
    trackSIWA_LookUpSuccessWithHiddenEmail,
    trackTermsOfServiceClicked as trackTermsOfServiceClickedAction,
    trackCommunityGuidelinesClicked as trackCommunityGuidelinesClickedAction,
    trackPrivacyPolicyClicked as trackPrivacyPolicyClickedAction,
} from '../../actions/gaTracking';

const _mapStateToProps = ({ authentication, form, social }) => ({
    form,
    email: authentication.email,
    socialData: social.socialData,
    socialProvider: social.socialProvider,
    locale: authentication.locale,
    recaptcha2PublicKey: authentication.recaptcha2PublicKey,
    recaptcha3PublicKey: authentication.recaptcha3PublicKey,
    showCaptcha: authentication.displayCaptcha,
    fp: authentication.fp,
    socialSSOSettings: authentication.socialSSOSettings,
    authNotificationOptions: authentication.authNotificationOptions,
    linkedAccountSuccessUrl: authentication.linkedAccountSuccessUrl,
    shouldRenderAuthNotification: !isEmpty(
        authentication.authNotificationOptions,
    ),
    authTypeSetting: authentication.authTypeSetting,
    stld: authentication.stld,
    disableRecaptcha3: authentication.disableRecaptcha3,
    referrer: authentication.referrer,
});

const _mapDispatchToProps = {
    onLookupUser: lookupUserAction,
    onLogInUser: logInUserAction,
    onSignUpUser: signUpUserAction,
    onSocialLogInUserNotAuthorized: socialLogInUserNotAuthorizedAction,
    onSocialLogInUserAuthorized: socialLogInUserAuthorizedAction,
    onSocialSignUpUser: socialSignUpUserAction,
    onSocialConnectVerified: socialConnectVerifiedAction,
    handleSocialProviderClick: socialProviderClickAction,
    onLinkAccountsOnLogin: linkAccountsOnLoginAction,
    moveBack: moveBackAction,
    onLinkedAccountsCreatePassword: sendResetPasswordEmailAction,
    handleForgotPassword: sendResetPasswordEmailAction,
    clearAuthNotification: clearAuthNotificationAction,
    onForceStld: forceStldAction,
    onGetStartedClick: trackGetStartedClickAction,
    onTermsOfServiceClick: trackTermsOfServiceClickedAction,
    onComunityGuidelinesClick: trackCommunityGuidelinesClickedAction,
    onPrivacyPolicyClick: trackPrivacyPolicyClickedAction,
    trackEmailConfirmationEdit: trackEmailConfirmationAction,
    trackEmailMismatchShowed: trackEmailMismatchAction,
    onLoginInsteadClick: trackLoginInsteadAction,
    trackSIWA_LookUpSuccessWithEmail,
    trackSIWA_LookUpSuccessWithHiddenEmail,
    handleSendMailLinkAccount: sendEmailLinkAccountAction,
};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(SignInScreen),
);
